// extracted by mini-css-extract-plugin
module.exports = {"closingOverlay":"ClosingOverlay_closingOverlay__2OxDU","darken":"ClosingOverlay_darken__RScwp"};